<script>
import {examPaperInfo, submitExerciseClass} from "@/utils/apis";
import common from "@/utils/common";
import ExamPaperTemplate from "@/components/teacherCourse/component/examPaperTemplate.vue";
import MarkIndex from "@/views/teach/MarkIndex.vue";

export default {
    name: 'ClassExercisePaper',
    components: {ExamPaperTemplate, MarkIndex},
    data() {
        return {
            query: JSON.parse(localStorage.getItem("query")) || null,
            paperContent: {},
            paperTitle: "",
            isSubmit: false,
        }
    },
    mounted() {
        this.getExercisePaperInfo()
    },
    methods: {
        goBack() {
            this.$router.go(-1)
        },
        submitData() {
            this.$confirm("提交则无法修改，确认提交？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
            }).then(() => {
                const params = {
                    activity_id: this.query.id,
                    data: this.paperContent,
                }
                submitExerciseClass(params).then(({code, msg, data}) => {
                    if (code === 200) {
                        this.$message({
                            type: "success",
                            message: msg,
                            duration: 1500,
                            onClose: () => this.getExercisePaperInfo()
                        })
                    } else {
                        this.$message.warning(msg)
                    }
                }).catch(err => common.axiosErrorMsg(err))
            }).catch(() => {})

        },
        getExercisePaperInfo() {
            const query = this.query
            examPaperInfo({id: query.id}).then(({code, msg, data}) => {
                if (code === 200)  {
                    this.paperContent = common.deepCopy(data.paper)
                    this.paperTitle = data.title
                    this.isSubmit = data.count > 0
                } else {
                    this.$message.warning(msg);
                }
            }).catch(err => common.axiosErrorMsg(err))
        }
    }

}

</script>

<template>
    <div class="exercise-paper">
        <el-scrollbar style="height:100%">
            <template v-if="isSubmit">
                <mark-index :id="query.id" />
            </template>
            <template v-else>
                <div class="paper-title">
                    <span>{{paperTitle}}</span>
                </div>
                <exam-paper-template :data.sync="paperContent" />
                <div class="btn-group">
                    <el-button class="w-120" @click="goBack">返回</el-button>
                    <el-button class="w-120" type="primary" @click="submitData">提交</el-button>
                </div>
            </template>
        </el-scrollbar>
    </div>

</template>

<style scoped lang="scss">
.exercise-paper {
    .btn-group {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .w-120 {
        width: 100px;
    }
    &, & * {
        box-sizing: border-box;
    }
    &:deep(.el-scrollbar) {
        .el-scrollbar__wrap {
            overflow-x: hidden;
        }

    }
    width: 100%;
    height: 100%;
    padding: 5px 10px;
    .paper-title {
        width: 100%;
        height: 70px;
        display: flex;
        justify-content: center;
        align-items: center;
        span {
            font-size: 24px;
            font-weight: bold;
        }
    }
}

</style>
